const searchSuggestion = [
  {
    integration: 'Clio',
    icon: 'clio-calendar-icon',
    logo: 'clio-logo-sm',
    description: 'Synch lead and client data with Clio.',
    link: '/ca/integrations/clio',
    category: ['popular-card', 'case-card'],
  },
  {
    integration: 'MyCase',
    icon: 'mycase-icon',
    logo: 'my-case-logo-sm',
    description: 'Save time with LEX updating client records in MyCase.',
    link: 'https://www.mycase.com',
    category: ['popular-card', 'case-card'],
  },
  {
    integration: 'LawPay',
    icon: 'lawpay-icon',
    logo: 'lawpay-logo-sm',
    description: 'Consultation to payment covered with LEX and LawPay.',
    link: 'https://www.lawpay.com/partners/lex-reception',
    category: ['popular-card', 'payments-card'],
  },
  {
    integration: 'Practicepanther',
    icon: 'practicepanther-black-icon',
    logo: 'practicepanther-logo-sm',
    description: 'Updates pushed to PracticePanther in real-time.',
    link: 'https://www.practicepanther.com',
    category: ['popular-card', 'case-card'],
  },
  {
    integration: 'Filevine',
    icon: 'filevine-black-icon',
    logo: 'filevine-logo-sm',
    description: 'Manage matters efficiently with LEX and Filevine.',
    link: 'https://www.filevine.com/integrations/lex-reception',
    category: ['popular-card', 'case-card'],
  },
  {
    integration: 'Lawmatics',
    icon: 'lawmatics-icon',
    logo: 'lawmatics-logo-sm',
    description: 'Automatically transfer new contacts to Lawmatics.',
    link: 'https://www.lawmatics.com',
    category: ['popular-card', 'case-card'],
  },
  {
    integration: 'Smokeball',
    icon: 'smokeball-icon',
    logo: 'smokeball-logo-sm',
    description: 'Add call and chat details into Smokeball.',
    link: 'https://www.smokeball.com',
    category: ['popular-card', 'case-card'],
  },
  {
    integration: 'CosmoLEX',
    icon: 'cosmoslex-icon',
    logo: 'cosmolex-logo-sm',
    description: 'Send contact updates to CosmoLex.',
    link: 'https://www.cosmolex.com',
    category: ['popular-card', 'case-card'],
  },
  {
    integration: 'CasePeer',
    icon: 'casepeer-icon',
    logo: 'casepeer-logo-sm',
    description: 'Call and chats sync\'d to CASEpeer.',
    link: 'https://www.casepeer.com',
    category: ['popular-card', 'case-card'],
  },
  {
    integration: 'Microsoft Teams',
    icon: 'microsoft-teams-icon',
    logo: 'microsoft-team-logo-sm',
    description: 'Call details added to your chats and channels.',
    link: 'https://www.microsoft.com/en-us/microsoft-teams/group-chat-software',
    category: ['popular-card', 'business-card'],
  },
  {
    integration: 'Law Ruler',
    icon: 'lawruler-icon',
    logo: 'lawruler-logo-sm',
    description: 'LEX exports new contacts to Law Ruler to track your client intake',
    link: 'https://www.lawruler.com',
    category: ['case-card'],
  },
  {
    integration: 'Rocket Matter',
    icon: 'rocket-matter-icon',
    logo: 'rocketmatter-logo-sm',
    description: 'Sync LEX contacts with your practice management system.',
    link: 'https://www.rocketmatter.com',
    category: ['case-card'],
  },
  {
    integration: 'Lawcus',
    icon: 'lawcus-icon',
    logo: 'lawcus-logo-sm',
    description: 'Track PNC\'s through Lawcus.',
    link: 'https://www.lawcus.com',
    category: ['case-card'],
  },
  {
    integration: 'Actionstep',
    icon: 'actionstep-icon',
    logo: 'actionstep-logo-sm',
    description: 'Automate your intake with a real-time sync.',
    link: 'https://www.actionstep.com',
    category: ['case-card'],
  },
  {
    integration: 'Canopy',
    icon: 'canopy-icon',
    logo: 'canopy-logo-sm',
    description: 'Intake and retain more clients with details sync\'d to Canopy.',
    link: 'https://www.getcanopy.com',
    category: ['more-case-card', 'case-card'],
  },
  {
    integration: 'Neos',
    icon: 'neos-icon',
    logo: 'neos-logo-sm',
    description: 'Client updates sent to Neos.',
    link: 'https://www.assemblysoftware.com/neos',
    category: ['more-case-card', 'case-card'],
  },
  {
    integration: 'Docketwise',
    icon: 'docketwise-icon',
    logo: 'docketwise-logo-sm',
    description: 'Call and chats added to Docketwise.',
    link: 'https://www.docketwise.com',
    category: ['more-case-card', 'case-card'],
  },
  {
    integration: 'Gravity Legal',
    icon: 'gravitylegal-icon',
    logo: 'gravitylegal-logo-sm',
    description: 'Client updates sync\'d to Gravity Legal.',
    link: 'https://www.gravity-legal.com',
    category: ['more-case-card', 'case-card'],
  },
  {
    integration: 'LegalBoards',
    icon: 'legalboard-icon',
    logo: 'legalboards-logo-sm',
    description: 'Feed client details into LegalBoards.',
    link: 'https://www.legalboards.com',
    category: ['more-case-card', 'case-card'],
  },
  {
    integration: 'Prima.law',
    icon: 'primalaw-icon',
    logo: 'primalaw-logo-sm',
    description: 'Import clients to your Prima.Law account.',
    link: 'https://www.prima.law',
    category: ['more-case-card', 'case-card'],
  },
  {
    integration: 'Daylite',
    icon: 'daylite-icon',
    logo: 'daylite-logo-sm',
    description: 'Calls and chats sync\'d to Daylite.',
    link: 'https://www.marketcircle.com',
    category: ['more-case-card', 'case-card'],
  },
  {
    integration: 'Salesforce',
    icon: 'salesforce-icon',
    logo: 'salesforce-logo-sm',
    description: 'Sales and call data sync\'d into Salesforce.',
    link: 'https://www.salesforce.com',
    category: ['crm-card'],
  },
  {
    integration: 'Zoho',
    icon: 'zoho-icon',
    logo: 'zoho-logo-sm',
    description: 'Automatically map sales and call data into Zoho.',
    link: 'https://www.zoho.com',
    category: ['crm-card'],
  },
  {
    integration: 'Pipedrive',
    icon: 'pipedrive-icon',
    logo: 'pipe-drive-logo-sm',
    description: 'Pipedrive contacts updated in real-time.',
    link: 'https://www.pipedrive.com',
    category: ['crm-card'],
  },
  {
    integration: 'Microsoft Dynamics 365',
    icon: 'dynamics-icon',
    logo: 'dynamics-logo-sm',
    description: 'Call details added to your chats and channels.',
    link: 'https://dynamics.microsoft.com/en-us',
    category: ['crm-card'],
  },
  {
    integration: 'Keap',
    icon: 'keap-icon',
    logo: 'keap-logo-sm',
    description: 'Automatically sync client data into Keap.',
    link: 'https://keap.com',
    category: ['crm-card'],
  },
  {
    integration: 'Freshsales',
    icon: 'freshsales-icon',
    logo: 'freshsales-logo',
    description: 'Client details instantly updated into Freshsales.',
    link: 'https://www.freshworks.com/crm/sales/',
    category: ['crm-card'],
  },
  {
    integration: 'Hubspot',
    icon: 'hubspot-icon',
    logo: 'hubspot-logo-sm',
    description: 'Automatically map marketing and call data to Hubspot.',
    link: 'https://hubspot.com',
    category: ['marketing-card'],
  },
  {
    integration: 'Mailchimp',
    icon: 'mailchimp-icon',
    logo: 'mailchimp-logo-sm',
    description: 'Build email lists with details sync\'d to MailChimp.',
    link: 'https://mailchimp.com',
    category: ['marketing-card'],
  },
  {
    integration: 'Mailer Lite',
    icon: 'mailerlite-icon',
    logo: 'mailer-logo-sm',
    description: 'Automate your email nurture through Mailer Lite.',
    link: 'https://www.mailerlite.com',
    category: ['marketing-card'],
  },
  {
    integration: 'ConstantContact',
    icon: 'constantcontact-icon',
    logo: 'constantcontact-logo',
    description: 'Use customer details to build subscriber lists.',
    link: 'https://www.constantcontact.com',
    category: ['marketing-card'],
  },
  {
    integration: 'ActiveCampaign',
    icon: 'activecampaign-icon',
    logo: 'activecampaign-logo-sm',
    description: 'Transfer new customer data to ActiveCampaign.',
    link: 'https://www.activecampaign.com',
    category: ['marketing-card'],
  },
  {
    integration: 'Zendesk',
    icon: 'zendesk-icon',
    logo: 'zen-desk-logo-sm',
    description: 'Map ticketing and call data to Zendesk.',
    link: 'https://www.zendesk.com',
    category: ['business-card'],
  },
  {
    integration: 'Freshdesk',
    icon: 'freshdesk-icon',
    logo: 'freshdesk-logo-sm',
    description: 'Automatically transfer updates into Freshdesk.',
    link: 'https://freshdesk.com',
    category: ['business-card'],
  },
  {
    integration: 'Trello',
    icon: 'trello-icon',
    logo: 'trelo-logo-sm',
    description: 'Keep your team up to date with details pushed to Trello.',
    link: 'https://trello.com',
    category: ['business-card'],
  },
  {
    integration: 'Slack',
    icon: 'slack-icon',
    logo: 'slack-logo-sm',
    description: 'Contact information synced directly to your Slack channel.',
    link: 'https://slack.com',
    category: ['business-card'],
  },
  {
    integration: 'Notion',
    icon: 'notion-icon',
    logo: 'notion-logo-sm',
    description: 'Sync updates into Notion.',
    link: 'https://www.notion.so',
    category: ['business-card'],
  },
  {
    integration: 'Podio',
    icon: 'podio-icon',
    logo: 'citrixpodio-logo-sm',
    description: 'Add contact details into Podio.',
    link: 'https://www.podio.com',
    category: ['business-card'],
  },
  {
    integration: 'Monday.com',
    icon: 'monday-icon',
    logo: 'monday-logo-sm',
    description: 'Push contact details into your workflow.',
    link: 'https://monday.com',
    category: ['business-card'],
  },
  {
    integration: 'Zapier',
    icon: 'zapier-icon',
    logo: 'zapier-logo-sm',
    description: 'Create custom zaps and connect with thousands of apps.',
    link: 'https://zapier.com/apps/lex-reception/integrations',
    category: ['business-card'],
  },
  {
    integration: 'Setmore',
    icon: 'setmore-icon',
    logo: 'setmore-logo-sm',
    description: 'Appointments, meetings and scheduling Anywhere.',
    link: 'https://www.setmore.com',
    category: ['scheduling-card'],
  },
  {
    integration: 'Google Calendar',
    icon: 'gcalendar-icon',
    logo: 'gcalendar-logo-sm',
    description: 'Consultations scheduled into your calendar.',
    link: 'https://calendar.google.com',
    category: ['scheduling-card'],
  },
  {
    integration: 'Clio Calendar',
    icon: 'clio-calendar-icon',
    logo: 'clio-calendar-logo-sm',
    description: 'Meetings scheduled at times that suit you.',
    link: 'https://www.clio.com/features/legal-calendaring/',
    category: ['scheduling-card'],
  },
  {
    integration: 'Office 365 Calendar',
    icon: 'microsoft365-icon',
    logo: 'microsoft365-logo-sm',
    description: 'Align appointment bookings in your Office 365 Calendar.',
    link: 'https://www.microsoft.com/en-us/microsoft-365',
    category: ['scheduling-card'],
  },
  {
    integration: 'Acuity Scheduling',
    icon: 'acuityscheduling-icon',
    logo: 'acuityscheduling-logo-sm',
    description: 'Appointments sync\'d to Acuity Scheduling.',
    link: 'https://acuityscheduling.com',
    category: ['scheduling-card'],
  },
  {
    integration: 'Quickbooks',
    icon: 'quickbooks-icon',
    logo: 'quickbooks-logo-sm',
    description: 'Export transaction details into QuickBooks.',
    link: 'https://quickbooks.intuit.com',
    category: ['accounting-card'],
  },
  {
    integration: 'Xero',
    icon: 'xero-icon',
    logo: 'xero-logo-sm',
    description: 'Send payment information to your Xero account.',
    link: 'https://www.xero.com/us/',
    category: ['accounting-card'],
  },
  {
    integration: 'Square',
    icon: 'square-icon',
    logo: 'square-logo-sm',
    description: 'Get paid consults using Square.',
    link: 'https://squareup.com/us/en/',
    category: ['payments-card'],
  },
  {
    integration: 'Stripe',
    icon: 'stripe-icon',
    logo: 'stripe-logo-sm',
    description: 'Collect payments through Stripe.',
    link: 'https://stripe.com',
    category: ['payments-card'],
  },
];

export default searchSuggestion;
